<template>
  <div class="row">
    <div class="col-xl-12">
      <div id="panel-1" class="panel">
        <div class="panel-container show">
          <el-row :gutter="10" class="m-2">
            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
              <el-input @input="debouncedQuerySever" type="text" size="medium"
                        v-model="form.name" class="mt-3"
                        placeholder="Tên, SĐT khách hàng"
                        clearable autocomplete="false"/>
            </el-col>

              <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                  <el-select v-if="[7,6].includes(keyAccount) || [295391, 266029].includes(currentUser.id)" @change="querySever(); getCenter()"
                             v-model="form.area_id" placeholder="Chọn Khu vực" filterable collapse-tags clearable
                             class="w-100 mt-3">
                      <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id"/>
                  </el-select>
              </el-col>

              <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-if="[5,6,7].includes(keyAccount) || [295391, 266029].includes(currentUser.id) || currentUser.profile.account_type_id === 18">
                  <el-select @change="querySever(); getChildUser(form.branch_id)"
                             v-model="form.branch_id" placeholder="Chọn văn phòng" filterable clearable
                             class="w-100 mt-3">
                      <el-option v-for="item in branches" :key="item.id" :label="item.name_alias || item.name" :value="item.id"/>
                  </el-select>
              </el-col>

              <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="7">
                  <tree-select v-model="cache_sale" :normalizer="normalizer" :options="options" :show-count="true"
                               class="w-100 mt-3 tree-customer" placeholder="Chọn nhân sự muốn xem..." search-nested
                               @input="handleChangeSale">
                      <label slot="option-label"
                             slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                             :class="labelClassName">
                          <img :src="publicPath + getImageHierarchy(node.raw.profile.account_type.id)" alt="">
                          <span>{{ node.label }} - {{ node.raw.id + 100000 }}</span>
                          <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                      </label>
                  </tree-select>
              </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
              <el-select @change="querySever" v-model="form.nguon" filterable clearable class="w-100 mt-3"
                         placeholder="Chọn kênh khách hàng">
                <el-option v-for="item in optionSource" :key="item.id" :label="item.value"
                           :value="item.value"/>
              </el-select>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
              <el-select @change="querySever" v-model="form.object_customer" clearable class="w-100 mt-3"
                         placeholder="Chọn đối tượng khách hàng">
                <el-option v-for="item in objectCustomer" :key="item.id" :label="item.value"
                           :value="item.id"/>
              </el-select>
            </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
              <el-date-picker
                  @change="querySever"
                  v-model="form.dateRange"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  clearable
                  start-placeholder="Từ ngày"
                  end-placeholder="Đến ngày"
                  class="w-100 mt-2" />
          </el-col>
          </el-row>
          <div class="d-flex justify-content-end m-2">
            <el-button @click="handleCreateNote()" size="medium" type="primary">
              <i class="el-icon-plus mr-1"></i> note khách hàng</el-button>
            <el-button @click="importNoteCustomerVisible=true" size="medium" type="success">
              <i class="el-icon-upload mr-1"></i>Upload ghi chú</el-button>
          </div>
          <div class="panel-content">
            <table class="table">
              <thead>
              <tr>
                <th>Họ tên</th>
                <th>Số điện thoại</th>
<!--                <th>Email</th>-->
                <th>Ngày sinh</th>
                <th>Đối tượng</th>
                <th>Kênh</th>
                <th>Phím nóng</th>
                <th>Người tạo</th>
                <th>Ngày tạo</th>
                <th class="text-center">Hành động</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(customer, idx) in customers"
                  :key="idx"
              >
                <td>{{ customer.name }}</td>
                <td>{{ customer.phone }}</td>
                <td>{{ customer.ngay_sinh ? $moment(customer.ngay_sinh).format('YYYY-MM-DD') : '' }}</td>
<!--                <td>{{ customer.email }}</td>-->
                <td>{{ objectCustomerDefine[customer.object_customer] }}</td>
                <td>{{ customer.nguon }}</td>
                  <td>
                  <el-button
                      type="primary"
                      size="mini"
                      @click="handleHotkey(customer)"
                  >
                    Chi tiết phím nóng
                  </el-button>
                </td>
                  <td>{{ customer.get_sale?.name }} - {{customer.get_sale.profile.branch.name_alias ??  customer.get_sale.profile.branch.name}}</td>
                  <td>{{ customer.created_at | formatDateTime }}</td>
                  <td>

                  <div class="text-center d-flex justify-content-edutalk">
                    <el-tooltip content="Sửa ghi chú" placement="top">
                      <a class="btn btn-success btn-sm btn-icon waves-effect waves-themed"
                         @click="handleEdit(customer)">
                        <i class="el-icon-edit"></i>
                      </a>
                    </el-tooltip>

                    <el-tooltip v-if="canActivate(customer)" content="chuyển đổi thành khách hàng" placement="top">
                      <a class="btn btn-success btn-sm btn-icon waves-effect waves-themed"
                         @click="convertNoteToCustomer(customer)">
                        <i class="el-icon-postcard"></i>
                      </a>
                    </el-tooltip>

                    <el-tooltip content="Xoá bản ghi chú" placement="top">
                      <a class="btn btn-danger btn-sm btn-icon waves-effect waves-themed"
                         @click="deleteNote(customer.id)">
                        <i class="el-icon-delete"></i>
                      </a>
                    </el-tooltip>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="edutalk-paging">
              <div class="block">
                <!--eslint-disable-->
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page.sync="current_page"
                    :page-size="per_page"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
              </div>
            </div>
              <div class="d-flex justify-content-end m-2">
                  <b class="mr-1">Tổng số bản ghi:</b> <b>{{total}}</b>
              </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Ghi chú thông tin khách hàng" :visible.sync="dialogNotCustomer" top="1vh" width="90%">
         <add-note-customer
             :customer="selectedCustomer"
             @close="dialogNotCustomer = false;"
             @reload="querySever()"
             @saved="onSaved"
         ></add-note-customer>
    </el-dialog>

    <el-dialog title="Chi tiết phím nóng" :visible.sync="dialogHotKeyDetail">
      <hr style="border: none; border-bottom: 1px solid #c0c4cc7d" class="mb-4">
      <hot-key-detail :hotkey="selectHotkey" :hot_key_detail="selectHotkeyDetail"></hot-key-detail>
    </el-dialog>

<!--    dialog xử lý upload ghi chú-->
    <el-dialog title="Import ghi chú khách hàng" :visible.sync="importNoteCustomerVisible">
      <dialogImportNoteCustomer
          @close="importNoteCustomerVisible = false;"
          @reload="querySever()"
      ></dialogImportNoteCustomer>
    </el-dialog>
  </div>
</template>

<script>
import AddNoteCustomer from "@/views/pages/customer/components/AddNoteCustomer.vue";
import HotKeyDetail from "@/views/pages/customer/HotKeyDetail.vue";
import {CUSTOMER_CREATE, GET_CUSTOMER_NOTE, DELETE_CUSTOMER_NOTE} from "@/core/services/store/customer/customer.module";
import {STATUS_CREATE} from "@/core/config/testInput/testInputOption";
import {BRANCH_LIST, GET_CHILD_USER} from "@/core/services/store/service.module";
import {GET_REGIONS_BY_USER} from "@/core/services/store/customer/customer.module";
import { debounce } from 'lodash';
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import dialogImportNoteCustomer from "@/views/pages/customer/components/DialogImportNoteCustomer.vue";
import {mapGetters} from "vuex";
export default {
  name: 'NoteCustomer',
  components: {dialogImportNoteCustomer, HotKeyDetail, AddNoteCustomer},
  data() {
    return {
      form: {
        name: '',
        phone: '',
        ngay_sinh: '',
        object_customer: '',
        nguon: '',
        hot_key: [],
        hot_key_detail: {},
        branch_id: '',
        area_id: '',
        sale: '',
        dateRange: []
      },
      branches: [], areas: [], options: [], cache_sale: null,
      current_page: 1,
      per_page: 50,
      total: 0,
      currentPage: 1,
      dialogNotCustomer: false,
      dialogHotKeyDetail: false,
      importNoteCustomerVisible: false,
      selectedCustomer: '',
      query: {page: 1, limit: 10, search: ''},
      selectHotkey: '',
      selectHotkeyDetail: '',
      debounceQuerySever: null,
      customers: [],
      objectCustomerDefine: {
        1: 'Học sinh',
        2: 'Sinh viên',
        3: 'Người đi làm',
      },
      imageHierarchy: {
        '5': 'media/hierarchy/gdvp.png',
        '1': 'media/hierarchy/sl.png',
        '2': 'media/hierarchy/se.png',
        '3': 'media/hierarchy/s.png',
        '4': 'media/hierarchy/si.png'
      },
      objectCustomer: [
        {id: 1, value: "Học sinh"},
        {id: 2, value: "Sinh viên"},
        {id: 3, value: "Người đi làm"},
      ],

      optionSource: [
        {id: 1, value: 'Nhân'},
        {id: 2, value: 'Nội bộ'},
        {id: 3, value: 'Ấm nóng'},
        {id: 4, value: 'Tiếp xúc lạnh'},
        {id: 5, value: 'Tái đăng ký'},
        {id: 6, value: 'Liên kết trường'},
        {id: 7, value: 'Lạnh'},
        {id: 8, value: 'Facebook ads'},
        {id: 9, value: 'Google ads'},
        {id: 10, value: 'Tiktok ads'},
        {id: 11, value: 'Vệ tinh'},
      ],
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Khách hàng", route: "customer-list"},
      {title: "Ghi chú dữ liệu khách hàng", icon: 'fas fa-users'}
    ]);
    this.getCenter();
    this.getRegions();
    this.getChildUser();
    this.querySever();
  },

  created() {
    this.debounceQuerySever = debounce(this.querySever, 2000);
  },

  methods: {
    debouncedQuerySever: _.debounce(function () {
      this.querySever();
    }, 1000),

    querySever() {
      this.form.page = this.current_page;
      this.form.per_page = this.per_page;
      const payload = this.form;
      this.$store.dispatch(GET_CUSTOMER_NOTE, payload).then((res) => {
        this.customers = res.data.data;
        this.total = res.data.total;
        this.per_page = res.data.per_page;
        this.loading = false;
      });
    },

    isValidPhone(phone) {
      const phoneRegex = /^(0|\+84)[0-9]{9,10}$/;
      return phoneRegex.test(phone);
    },

    canActivate(c) {
      if (!c.name || !c.phone || !c.ngay_sinh || !c.object_customer || !c.nguon) {
        return false;
      }

      if (!this.isValidPhone(c.phone)) {
        return false;
      }

      if (c.hot_key.length) {
        let keys, details;
        try {
          keys = Array.isArray(c.hot_key) ? c.hot_key : JSON.parse(c.hot_key);
          details = typeof c.hot_key_detail === 'object'
              ? c.hot_key_detail
              : JSON.parse(c.hot_key_detail || '{}');
        } catch {
          return false;
        }
        if (Array.isArray(keys) && keys.length) {
          return keys.every(id => details[id] && details[id].toString().trim().length > 0);
        }
      }else {
        return false;
      }
      return true;
    },

    handleHotkey(customer) {
      this.selectHotkey = customer.hot_key ?? [];
      this.selectHotkeyDetail =customer.hot_key_detail ?? [];
      this.dialogHotKeyDetail = true;
    },
    handleEdit(customer) {
      this.selectedCustomer = customer;
      console.log('this.selectedCustomer', this.selectedCustomer);
      this.dialogNotCustomer = true;
    },
    onSaved() {
      this.querySever();
    },

    deleteNote(note_id){
      this.$confirm('Bạn có chắc chắn muốn xoá ghi chú này?', 'Xoá ghi chú', {
        confirmButtonText: 'Xoá',
        cancelButtonText: 'Huỷ',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch(DELETE_CUSTOMER_NOTE, {id:note_id}).then((res) => {
          this.querySever();
          this.$notify({
            title: 'Xoá ghi chú',
            message: res.message ?? 'Thành công',
            type: 'success'
          });
        }).catch((error) => {
          this.$notify({
            title: 'Xoá ghi chú',
            message: error.message || 'Có lỗi xảy ra',
            type: 'error'
          });
        });
      }).catch(() => {

      });
    },

    convertNoteToCustomer(customer) {
      this.$confirm(
          'Bạn có chắc chắn muốn chuyển đổi ghi chú này thành khách hàng?',
          'Tạo khách hàng',
          {
            confirmButtonText: 'Tạo',
            cancelButtonText: 'Huỷ',
            type: 'warning'
          }
      ).then(() => {
        const payload = {
          ...customer,
          idNote: customer.id,
          id: ''
        };

      this.$store.dispatch(CUSTOMER_CREATE, payload)
          .then((res) => {
            if (!res.error) {
              this.handleSuccess();
            } else {
              this.notify('Thêm khách hàng', res.message, 'error');
            }
          })
          .catch((error) => {
            const msg = error?.data?.message;
            if (msg && this.$refs.form?.setErrors) {
              this.$refs.form.setErrors(msg);
            }
            this.notify('Thêm khách hàng', 'Có lỗi xảy ra', 'error');
          });
      }).catch(() => {
        // Người dùng huỷ => không làm gì cả
      });
    },

    handleSuccess() {
      const notifySuccess = () => {
        this.notify('Thêm khách hàng', 'Thành công', 'success');
      };

      if (this.statusCreateTestInput === STATUS_CREATE) {
        notifySuccess();
      } else {
        this.$router.push({ name: "customer-list" }).then(() => {
          notifySuccess();
        });
      }
    },

    notify(title, message, type = 'success') {
      this.$notify({ title, message, type });
    },

    handleCreateNote() {
      this.dialogNotCustomer = true;
      this.selectedCustomer = null;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.querySever({page: val});
    },
    getCenter () {
        this.form.branch_id = '';
      this.$store.dispatch(BRANCH_LIST, { area_id: this.form.area_id }).then(res => {
          if (res.status === 422) this.$message({ type: 'warning', message: `${res.message}`, showClose: true })
          else this.branches = res.data
      })
    },

    getRegions () {
      const payload = { all: this.keyAccount === 7 ? 1 : 0 }
      this.$store.dispatch(GET_REGIONS_BY_USER, payload).then(res => {
          if (res.status === 422) this.$message({ type: 'warning', message: `${res.message}`, showClose: true })
          else this.areas = res.data
      })
    },
    getChildUser () {
      const payload = { branch_id: this.form.branch_id ?? '' }
      this.$store.dispatch(GET_CHILD_USER, payload).then(res => {
          if (res.status === 422) this.$message({ type: 'warning', message: `${res.message}`, showClose: true })
          else this.options = res.data
      })
    },

      handleChangeSale () { this.form.sale = this.cache_sale; this.querySever() },
      normalizer (node) { return { id: node.id, label: node.name } },
      getImageHierarchy (account_type) { return this.imageHierarchy[account_type] },
  },

    computed: {
        ...mapGetters(['currentUser', 'keyAccount']),
    }
};
</script>

<style scoped>
.text-danger {
  color: #f56c6c;
}
</style>
